import React from 'react';
import { VACATION_LENGTHS, rangeEndStr, formatVacationRange } from '../../constants/vacationRange';

// Start date (any day) + length (1–4 weeks) + read-only result line
export default function VacationRangePicker({ startDate, lengthDays, onChange, min, max, disabled }) {
  const endDate = startDate ? rangeEndStr(startDate, lengthDays) : null;
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        <div className="form-group" style={{ flex: '1 1 160px', marginBottom: 0 }}>
          <label className="form-label" htmlFor="vacation-start">Start date</label>
          <input
            id="vacation-start"
            type="date"
            className="form-input"
            value={startDate || ''}
            min={min || undefined}
            max={max || undefined}
            disabled={disabled}
            onChange={(e) => onChange({ start_date: e.target.value, length_days: lengthDays })}
          />
        </div>
        <div className="form-group" style={{ flex: '1 1 130px', marginBottom: 0 }}>
          <label className="form-label" htmlFor="vacation-length">Length</label>
          <select
            id="vacation-length"
            className="form-input"
            value={lengthDays}
            disabled={disabled}
            onChange={(e) => onChange({ start_date: startDate, length_days: Number(e.target.value) })}
          >
            {VACATION_LENGTHS.map((l) => (
              <option key={l.days} value={l.days}>{l.label}</option>
            ))}
          </select>
        </div>
      </div>
      <div
        style={{
          marginTop: '10px', padding: '8px 12px', borderRadius: 'var(--radius)',
          background: 'var(--primary-xlight)', border: '1px solid var(--primary)',
          fontSize: '0.86rem', fontWeight: 600, color: endDate ? 'var(--text)' : 'var(--text-muted)',
        }}
      >
        {endDate ? formatVacationRange(startDate, endDate) : 'Pick a start date'}
      </div>
    </div>
  );
}
